import {
  IconoirTrash,
  IconoirEditPencil,
  IconoirDownload,
  IconoirCopy,
  MotifNavigationIcClose24px,
} from "@ey-xd/motif-icon";
import { MotifButton, MotifIcon } from "@ey-xd/motif-react";
import CommonTooltipWrapper from "../Tooltip/CommonTooltipWrapper";
import { useTranslation } from "react-i18next";
import { IconoirArrowUp, IconoirArrowDown } from "@ey-xd/motif-icon";

export const DELETE_IMG_VARIANT = "secondary";

export const DOWNLOAD_IMG_VARIANT = "secondary";

export const EDIT_IMG_VARIANT = "secondary";

export const YES_BUTTON_VARIANT = "primary";

export const NO_BUTTON_VARIANT = "secondary";

export const NEXT_BUTTON_VARIANT = "primary";

export const SAVE_BUTTON_VARIANT = "primary";

export const CANCEL_BUTTON_VARIANT = "secondary";

export const ADD_BUTTON_VARIANT = "primary";

export const CREATE_BUTTON_VARIANT = "secondary";

export const APPLY_BUTTON_VARIANT = "primary";

export const EDIT_BUTTON_VARIANT = "secondary";

export const UPDATE_BUTTON_VARIANT = "primary";

export const REMOVE_BUTTON_VARIANT = "secondary";

export const UPLOAD_BUTTON_VARIANT = "primary";

export const CONFIRM_BUTTON_VARIANT = "primary";

export const REFRESH_BUTTON_VARIANT = "primary";

export const EXPORT_BUTTON_VARIANT = "secondary";

export const RELOAD_BUTTON_VARIANT = "secondary";

export const PREVIEW_BUTTON_VARIANT = "secondary";

export const OK_BUTTON_VARIANT = "primary";

export const DELETE_BUTTON_VARIANT = "primary";
export const COPY_BUTTON_VARIANT = "secondary";
export const CLOSE_BUTTON_VARIANT = "secondary";
export const ARROW_UP_IMG_VARIANT = "secondary";
export const ARROW_DOWN_IMG_VARIANT = "secondary";

export const getCommonDeleteImg = () => {
  return (
    <MotifIcon
      iconFunction={IconoirTrash}
      stroke="blue"
      strokeWidth="2"
      size="12"
    />
  );
};
export const getCommonUpArrowImg = () => {
  return <MotifIcon iconFunction={IconoirArrowUp} size="24" />;
};
export const getCommonDownArrowImg = () => {
  return <MotifIcon iconFunction={IconoirArrowDown} size="24" />;
};
export function GetCommonUpArrowImgButton({ onClick, disabled }: any) {
  const { t } = useTranslation();
  return (
    <span className="motif-table-arrowImage-button-con">
      <CommonTooltipWrapper tooltipTitle={t("global.globalActions.moveUp")}>
        <MotifButton
          style={{ height: "2.2rem" }}
          variant={ARROW_UP_IMG_VARIANT}
          onClick={() => onClick()}
          disabled={disabled}
          type="button"
        >
          {getCommonUpArrowImg()}
        </MotifButton>
      </CommonTooltipWrapper>
    </span>
  );
}
export function GetCommonDownArrowImgButton({ onClick, disabled }: any) {
  const { t } = useTranslation();
  return (
    <span className="motif-table-arrowImage-button-con">
      <CommonTooltipWrapper tooltipTitle={t("global.globalActions.moveDown")}>
        <MotifButton
          style={{ height: "2.2rem" }}
          variant={ARROW_DOWN_IMG_VARIANT}
          onClick={() => onClick()}
          disabled={disabled}
          type="button"
        >
          {getCommonDownArrowImg()}
        </MotifButton>
      </CommonTooltipWrapper>
    </span>
  );
}
export function GetCommonDeleteImgButton({
  onClick,
  disabled,
  tooltipPlacment,
}: any) {
  const { t } = useTranslation();
  return (
    <span className="motif-table-action-button-con">
      <CommonTooltipWrapper
        placement={tooltipPlacment}
        tooltipTitle={t("global.globalActions.delete")}
      >
        <MotifButton
          style={{ height: "2.2rem" }}
          variant={DELETE_IMG_VARIANT}
          onClick={(e: any) => onClick(e)}
          disabled={disabled}
          type="button"
        >
          {getCommonDeleteImg()}
        </MotifButton>
      </CommonTooltipWrapper>
    </span>
  );
}
export function GetCommonEditImgButton({
  onClick,
  disabled,
  tooltipPlacment,
}: any) {
  const { t } = useTranslation();
  return (
    <span className="motif-table-action-button-con">
      <CommonTooltipWrapper
        placement={tooltipPlacment}
        tooltipTitle={t("global.globalActions.edit")}
      >
        <MotifButton
          style={{ height: "2.2rem" }}
          variant={EDIT_IMG_VARIANT}
          onClick={() => onClick()}
          disabled={disabled}
          type="button"
        >
          {getCommonEditImg()}
        </MotifButton>
      </CommonTooltipWrapper>
    </span>
  );
}
export function GetCommonDownloadImgButton({
  onClick,
  disabled,
  loading,
  tooltipText,
  style,
}: any) {
  const { t } = useTranslation();
  return (
    <span className="motif-table-action-button-con" style={style}>
      <CommonTooltipWrapper
        tooltipTitle={tooltipText || t("global.globalActions.viewOrDownload")}
      >
        <MotifButton
          style={{ height: "2.2rem" }}
          variant={DOWNLOAD_IMG_VARIANT}
          onClick={() => onClick()}
          disabled={disabled}
          loading={loading}
          type="button"
        >
          {getCommonDownloadImg()}
        </MotifButton>
      </CommonTooltipWrapper>
    </span>
  );
}

export const getCommonEditImg = (size = "24") => {
  return (
    <MotifIcon iconFunction={IconoirEditPencil} strokeWidth="2" size={size} />
  );
};

export const getCommonDownloadImg = () => {
  return <MotifIcon iconFunction={IconoirDownload} strokeWidth="2" size="24" />;
};

export const getCommonCopyImg = () => {
  return <MotifIcon iconFunction={IconoirCopy} strokeWidth="2" size="24" />;
};

export const getCommonCloseImg = () => {
  return (
    <MotifIcon
      iconFunction={MotifNavigationIcClose24px}
      strokeWidth="2"
      size="24"
    />
  );
};
